//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formPage from './form'
import listPage from './summaryList'


export default {
    components: { formPage,listPage },
    props: [],
    data () {
        return {
            tableData: [],
            tableDataFilter: [],
            pgData: {},

            formDialogVisible: false,
            listDialogVisible: false,
            dialogTitle: '',

            dialogVisible_branch: false,
            dialogTitle_branch: '',

            uploadDialogVisible:false,

            formSearch: {
                id: ''
            },
            addSummary:true,
            firstBankName:"",
            bhxyCode:"",
            fileguid:""
        }
    },
    watch: {
        dialogVisible(n, o) {
            !n && this.reloadHandler();
        },
        dialogVisible_branch(n, o) {
            !n && this.reloadHandler();
        },
        tableData(n,o){
            this.tableDataFilter = this.tableData.filter((item)=>{
                return item.auditStatus == '2';
            })
        },
    },
    methods: {
        listClose(){
            this.listDialogVisible = false;
            this.reloadHandler();
        },
        detailHandler(row){
            sessionStorage.setItem('id',row.id);
            sessionStorage.setItem('type','detail');
            this.goto('../entry/detail');
        },
        fielUploadSuccess(){
            this.$post(this.getStore('bankguart') + '/gua_order/'+this.uploadid+'/upload',{
                fileguid:this.fileguid
            },(data)=>{
                this.uploadDialogVisible = false;
            })
        },
        uploadHandler(row){
            this.dialogTitle = "上传";
            this.uploadDialogVisible = true;
            this.fileguid = this.GenNonDuplicateID();
            this.uploadid = row.id;
        },
        undoHandler(row){
            var that = this;
            this.$confirm('确认撤单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$ajax({
                    type:'post',
                    url:that.getStore('bankguart') + '/gua_hz/'+row.id+'/revoke',
                    data:{},
                    callback:function(data,res){
                        that.$notify({
                            title: '成功',
                            message: '撤单成功',
                            type: 'success'
                        });
                        that.reloadHandler();
                    },
                    error:function(data,res){
                        console.log(data);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        selectable(row){
            return row.isHz == "0";
        },
        getRowKeys:function(row){
            return row.id;
        },
        handleSelectionChange(val){
            if(val.length > 0){
                this.firstBankName = val[0].branchName;
                this.addSummary = false;
                this.formSearch.id = "";
                for(var i = 0;i < val.length;i++){
                    this.formSearch.id += val[i].id + ',';
                }
            }else{
                this.addSummary = true;
            }
        },
        summerHandler() {
            var that = this;
            this.$get(that.getStore('bankguart') + '/gua_hz/bhxy_code',{
                branchName:that.firstBankName
            },function(data,res){
                that.bhxyCode = data;
                that.dialogTitle_branch = '添加汇总';
                that.formDialogVisible = true;
            })
        },
        summerListHandler(){
            this.dialogTitle_branch = '我的汇总';
            this.listDialogVisible = true;
        },
        reloadHandler() {
            this.$refs.table.clearSelection();
            this.$refs.page.queryData(0);
        },
        summaryClose(){
            this.formDialogVisible = false;
            this.reloadHandler();
        },
        GenNonDuplicateID(){//获取随机字符串
            let idStr = Date.now().toString(36);
            idStr += Math.random().toString(36).substr(3);
            return idStr;
        },
    },
    mounted: function() {
        
    }
}
